<template>
  <j-card class="flex wrap p4 xs-12 xs-right bg5">
    <core-form-input
      class="mb2"
      name="email"
      componentName="j-base-input-text"
      :label="$t('email')"
      v-model="emailAddress"
    />
    <j-button @click="sendTestEmail" :isLoading="isLoading">{{$t('send_test')}}</j-button>
  </j-card>
</template>

<script>
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CoreFormInput from "@/modules/core/components/CoreFormInput"

import api from "../../api/"
import dayjs from "dayjs"

export default {
  components: {
    JCard,
    JButton,
    CoreFormInput
  },

  props: {
    template: Object,
    graphQlVariables: String
  },

  data() {
    return {
      emailAddress: null,
      isLoading: false
    }
  },

  methods: {
    async sendTestEmail() {

      if (!this.emailAddress) {
        this.$store.dispatch("addMessage", {
          message: {
            type: "error",
            text: "name_field_required"
          }
        }) 
        return
      } 

      this.isLoading = true

			const res = await api.sendNotification({
				input: {
					type: "testMjmlTemplate",
					emailMessage: {
						to: this.emailAddress,
						subject: `${
							this.template.name
						} ${dayjs().format("YYYY-DD-MM:HH:mm:ss")}`,
						from: "admin@covergo.com",
						templateRendering: {
              templateId: this.$route.params.id,
              input: {
                name: "data",
                variablesJsonString: this.graphQlVariables ? this.graphQlVariables : "{}"
              }
						}
					}
				}
      })

      this.isLoading = false
      this.emailAddress = null

			if (res.errors) this.$store.dispatch("showError", res.errors)
			else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("send_test_successful")
					}
				})
		}
  }
}
</script>